module.exports = __webpack_public_path__ + "img/app-bio-logo.87ff6be3.png";